// extracted by mini-css-extract-plugin
export default {"productcontainer":"admin_productcontainer__DA5QP"};